import { useLoaderData } from 'react-router';
import { paths } from '../../../../../common/constants/pathVariables.js';
import { useTitle } from '../../../../../common/hooks/useTitle.js';
import { omaElisaForEmployeeMsg, orderRequestsMsg, t } from '../../../../../common/i18n/index.js';
import { getFilteredSubscriptionActions } from '../../../../../common/utils/employeeUtils.js';
import { EoeOrdersBreadcrumb, EoeOrdersNavi } from '../../../../../components/EoeOrdersWrapper/EoeOrdersWrapper.js';
import { Grid } from '../../../../../components/Grid/Grid.js';
import { RedeemRequestList } from '../../../../../components/SubscriptionAction/RedeemRequestList';
import { useAuth } from '../../../AuthProvider';
import type { SubscriptionActionsResponse } from '../../../../../generated/api/subscriptionActionsResponse';

export const EoeChangeRequestsPath = () => {
  const { authenticatedUser } = useAuth();
  const { searchResults, total } = useLoaderData() as SubscriptionActionsResponse;

  useTitle([t.H6JV(omaElisaForEmployeeMsg), t.Y29L(orderRequestsMsg)]);

  return (
    <>
      <EoeOrdersBreadcrumb />
      <EoeOrdersNavi />
      <Grid>
        <RedeemRequestList
          basePath={paths.EMPLOYEE_CHANGE_REQUEST_ORDER}
          redeemRequests={getFilteredSubscriptionActions(searchResults)}
          totalItems={total}
          authenticatedUser={authenticatedUser}
        />
      </Grid>
    </>
  );
};
